<template lang="pug">
.page(:style='openWanliuWindow?pageHeight:""')
  .have-data(v-if="showNodata")
    .card-container-block
      .rule-block(@click="goRule")
        img(src="https://m.hellobike.com/resource/helloyun/08345/CTLnJO0crq.png?x-oss-process=image/quality,q_80")
      .hot-block(v-if="hotData.title"
        :style='(hotData.paymentLimit === 1 && hotData.isCard)?"height:2.07rem":""')
        .hot-block-title
          .title-word 限时特惠
          .title-time(v-if="hotData.isCard&&timeout")
            .title-time-block {{h}}
            .title-time-block-dot :
            .title-time-block {{m}}
            .title-time-block-dot :
            .title-time-block {{s}}
        .hot-block-info
          CardC(:mode='hotData.isCard?1:2'
                :hot="true"
                :info="hotData"
              )
          .buy-btn(@click="toBuy")
            Lottie.lottie(:url="json")
            .btn-sign(v-if="signMoney>0")
              span 补贴已省{{signMoney}}元
    .card-list(v-if="firstList.length>0||secondList.length>0"
        :style='(hotData.paymentLimit === 1 && hotData.isCard) ? "marginTop:-0.73rem":""')
      .card-list-title(v-if="firstList.length>0")
        span {{topModule==='bike'?'单车':'助力车'}}卡券
        span(style="color:#FF5526") 1折
        span 起
      .first-cardList(v-for="item in firstList"
        :style="item.paymentLimit===1&&item.isCard?'height:1.13rem':''")
        CardC(@click='openConfirm'
              :mode='item.isCard?1:2'
              :info="item"
            )
      .second-title(v-if="secondList.length>0")
        span {{topModule!=='bike'?'单车':'助力车'}}卡券
        span(style="color:#FF5526") 1折
        span 起
      .second-cardList(v-for="item in secondList"
        :style="item.paymentLimit===1&&item.isCard?'height:1.13rem':''")
        CardC(@click='openConfirm'
              :mode='item.isCard?1:2'
              :info="item"
            )
      .godownload(v-if="!isApp&&!isWechatMini", @click="goDownload")
        .download-img
          img(src="https://m.hellobike.com/resource/helloyun/08345/5tCRE_Fill%201@3x.png?x-oss-process=image/quality,q_80")
        .download-word 立即下载哈啰APP
        .download-arrow
          img(src="https://m.hellobike.com/resource/helloyun/08345/nF4SWUxAZm.png?x-oss-process=image/quality,q_80")
    .no-list-block(v-else)
      .no-list-title(v-if="hotData.title") 更多活动推荐
      .no-list-banner
        adv-master(
          v-if="bannerPropById.id"
          class="banner-container"
          :bannerProp="bannerPropById"
          :env="envConfig"
          :systemCode="systemCode"
        )
      .no-list-download(v-if="isAliMP||isAli", @click="goDownload")
        img.no-img(src="https://m.hellobike.com/resource/helloyun/08345/rviC4vjGep.png?x-oss-process=image/quality,q_80")
      .no-list-img-block
    ConfirmC(v-if='showBuyConfirm', @close='closeConfirm' :info="card" @confirm="onConfirmRight")
    Wanliu(ref='wanliu'
      @cancel="closeWanliu"
      @cancelRight="toBuyWanliu"
      :styleV='wanliuStyle')
    NewCardModal(
      :show="showModal",
      :windowData="windowData",
      @show-buy="hotBuy"
      @close="closeModal")
  .no-data(v-else)
    .nodata-img
      Lottie.lottieNodata(:url="'https://m.hellobike.com/resource/helloyun/08345/NIjQB_loading.json'")
    .nodata-info 正在努力加载中
</template>

<script>
import Lottie from '@/components/lottie';
import { AdvMaster } from '@hb/h5-components';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { startApp } from '@/utils/index';
import { getEmotion, getCardList } from '@/api/card';
import { CardService } from '@/service/card';
import { env } from '@hb/NBridge/lib/h5';
import { Storage } from '@/utils/storage';
import NewCardModal from './components/new-card-modal';
import CardC from './components/card-c.vue';
import ConfirmC from './components/confirm-c.vue';
import Wanliu from './components/wanliu.vue';
import { ParamsUtil } from '../../../utils/params';
import { getVersion, getSystemCode } from '../../../utils/systemCode';
import {
  getTokenAndLocation,
} from '../../../utils';
import config from '../../../const/config';

export default {
  components: {
    CardC,
    ConfirmC,
    Wanliu,
    NewCardModal,
    Lottie,
    AdvMaster,
  },

  data() {
    return {
      windowData: {},
      showModal: false,
      showBuyConfirm: false,
      card: {
        title: '单车30天不限次卡·APP专享',
        currentPrice: '32',
        businessType: 1,
        originPrice: '50',
        save: '18',
        img: '',
        tags: [{ wordsValue: '全国可用' }, { wordsValue: 'APP专享限时补贴' }],
      },
      hotData: {},
      signMoney: 0,
      topModule: '',
      firstList: [],
      secondList: [],
      isApp: env.isEasyBikeApp,
      isAli: env.isAliMPMonitor,
      isAliMP: env.isAliMP,
      isWechatMini: env.isWechatMini,
      h: '',
      s: '',
      m: '',
      config: {
        deepLink:
          'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280&beyondMP=true',
        ruleLink:
          'https://m.hellobike.com/mf/spa/u_tsncbi/latest/MA2205183125773328723214336.html?activityCode=MA2205183125773328723214336',
      },
      timer: null,
      wanliuStyle: 'v1',
      firstCoupon: {},
      json: 'https://m.hellobike.com/resource/helloyun/08345/sxIj7DLUto.json',
      envConfig: config.env,
      systemCode: null,
      showNodata: false,
      timeout: 0,
      openWanliuWindow: false,
      pageHeight: 'height:100%',
    };
  },
  computed: {
    bannerPropById() {
      return {
        id: '8d2aa1761b0844169c40bdc80b471b78',
        customClick: false,
        style: {
          borderRadius: 0,
          height: 80,
        },
      };
    },
  },
  beforeRouteLeave(to, form, next) {
    UBT.pageViewOut({
      pageId: 'platform_appmarketing',
      categoryId: 'platform',
      businessInfo: {
        adsource: ParamsUtil.getParams(window.location.href).adsource,
      },
    });
    next();
  },
  created() {
    if (getSystemCode) {
      this.systemCode = getSystemCode().toString();
    }
    UBT.moduleExpose({
      pageId: 'platform_appmarketing',
      categoryId: 'platform',
      moduleId: 'platform_newrule',
      contentId: 'platform_newrule',
      exposureTimes: 1,
      businessInfo: {},
    });
  },
  mounted() {
    UBT.pageView({
      pageId: 'platform_appmarketing',
      categoryId: 'platform',
      businessInfo: {
        adsource: ParamsUtil.getParams(window.location.href).adsource,
      },
    });
    // this.getEmotionFun();
    this.getCardList();
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    goRule() {
      UBT.clickButton({
        pageId: 'platform_appmarketing',
        buttonName: 'platform_newrule',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.goUrl(this.config.ruleLink);
    },
    gettime() {
      if (this.hotData.expiredTime && this.hotData.expiredTime > 0) {
        this.timeout = this.hotData.expiredTime;
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          this.showTime(this.timeout);
          this.timeout -= 1000;
          if (this.timeout <= 0) {
            clearInterval(this.timer);
          }
        }, 1000);
      }
    },
    showTime(timeout) {
      // 后台给我的是10位 精确到秒的  所有下面我就除以了1000，不要小数点后面的
      // eslint-disable-next-line no-console
      if (timeout) {
        const t = timeout;
        // eslint-disable-next-line no-console
        // 如果后台给的是毫秒 上面不用除以1000  下面的计算时间也都要除以1000 这里我去掉1000了
        let d = Math.floor(t / 60 / 60 / 24);// 天 var d=Math.floor(t/1000/60/60/24)
        // eslint-disable-next-line no-mixed-operators
        const h = Math.floor(t / 1000 / 60 / 60 % 24);
        // 时 var h=Math.floor(t/1000/60/60%24)
        // eslint-disable-next-line no-mixed-operators
        const m = Math.floor(t / 1000 / 60 % 60);// 分 var m=Math.floor(t/1000/60%60)
        // eslint-disable-next-line no-mixed-operators
        const s = Math.floor(t / 1000 % 60);// 秒 var s=Math.floor(t/1000%60)
        if (parseInt(d, 10) < 10) {
          d = `0${d}`;
        }
        if (parseInt(h, 10) < 10) {
          this.h = `0${h}`;
        } else {
          this.h = `${h}`;
        }
        if (parseInt(m, 10) < 10) {
          this.m = `0${m}`;
        } else {
          this.m = `${m}`;
        }
        if (parseInt(s, 10) < 10) {
          this.s = `0${s}`;
        } else {
          this.s = `${s}`;
        }
      }
    },
    async getEmotionFun() {
      // eslint-disable-next-line no-unused-vars
      const { cityCode, adCode, token } = await getTokenAndLocation();
      try {
        const res = await getEmotion({
          token,
          action: 'user.platform.emotion',
          pageType: 18,
          cityCode,
          adCode,
          version: await getVersion(),
          systemCode: getSystemCode(),
        });
        if (res.data) {
          const nowDate = this.getDate();
          const chenjinDate = await Storage.getItem('chenjin-date');
          // eslint-disable-next-line no-console
          console.log('nowDate', nowDate);
          // eslint-disable-next-line no-console
          console.log('chenjinDate', chenjinDate);
          // eslint-disable-next-line no-console
          console.log('new Date().getTime()', new Date().getTime());
          if (
            new Date().getTime() > res.data.startTime
          && new Date().getTime() < res.data.endTime
          && (chenjinDate !== nowDate)
          ) {
            UBT.moduleExpose({
              pageId: 'platform_appmarketing',
              categoryId: 'platform',
              moduleId: 'platform_immersive',
              contentId: 'platform_immersive',
              exposureTimes: 1,
              businessInfo: {
                activityname: res.data.mainTitle,
              },
            });
            this.showModal = true;
            Storage.setItem('chenjin-date', nowDate);
          }
          this.windowData = res.data;
        }

        // eslint-disable-next-line no-empty
      } catch (e) {
      }
    },
    async getCardList() {
      // eslint-disable-next-line no-unused-vars
      const { cityCode, adCode, token } = await getTokenAndLocation();
      try {
        const res = await getCardList({
          token,
          action: 'common.welfare.arrgdata',
          pageType: 18,
          adCode,
          cityCode,
          systemCode: getSystemCode(),
          version: await getVersion(),
        });
        // eslint-disable-next-line no-console
        console.log('res', res);
        if (res && res.data) {
          this.hotData = res.data.hotData || {};
          UBT.moduleExpose({
            pageId: 'platform_appmarketing',
            categoryId: 'platform',
            moduleId: 'platform_explosive',
            contentId: 'platform_explosive',
            exposureTimes: 1,
            businessInfo: {
              business_line: this.hotData.businessType,
              businessType: this.hotData.isCard ? '0' : '1',
            },
          });
          this.getEmotionFun();
          this.getMoney();
          this.topModule = res.data.topModule;
          if (this.topModule === 'bike') {
            this.firstList = res.data.bike;
            this.secondList = res.data.ebike;
          } else {
            this.firstList = res.data.ebike;
            this.secondList = res.data.bike;
          }
          if (this.firstList) {
            if (this.firstList.length > 0) {
              this.firstCoupon = this.firstList.find((i) => !i.isCard);
            } else if (!this.firstCoupon || this.firstList.length === 0) {
              this.firstCoupon = this.secondList.find((i) => !i.isCard);
            }
            const allList = res.data.bike.concat(res.data.ebike);
            allList.forEach((item) => {
              if (!item.isCard) {
                UBT.moduleExpose({
                  pageId: 'platform_appmarketing',
                  categoryId: 'platform',
                  moduleId: 'platform_appnewcoupon',
                  contentId: 'platform_appnewcoupon',
                  exposureTimes: 1,
                  businessInfo: {
                    cardname: item.title,
                    business: item.businessType,
                  },
                });
              } else {
                UBT.moduleExpose({
                  pageId: 'platform_appmarketing',
                  categoryId: 'platform',
                  moduleId: 'platform_appnewcard',
                  contentId: 'platform_appnewcard',
                  exposureTimes: 1,
                  businessInfo: {
                    cardname: item.title,
                    business: item.businessType,
                  },
                });
              }
            });
          } else {
            this.firstList = [];
            this.secondList = [];
          }

          this.wanliuStyle = res.data.style;
          this.gettime();
        }
        this.showNodata = true;
      // eslint-disable-next-line no-empty
      } catch (e) {
        this.showNodata = true;
      }
    },
    async toBuy() {
      UBT.clickButton({
        pageId: 'platform_appmarketing',
        buttonName: 'platform_explosive',
        categoryId: 'platform',
        businessInfo: {
          business_line: this.hotData.businessType,
          businessType: this.hotData.isCard ? '0' : '1',
        },
      });
      if (!this.hotData.isCard) {
        const { token, adCode, cityCode } = await getTokenAndLocation();
        window.location.href = ParamsUtil.addParams(this.hotData.buttonLink,
          { token, adCode, cityCode });
      } else {
        this.openConfirm(this.hotData);
      }
    },
    getMoney() {
      if (this.hotData) {
        let money = (this.hotData.originPrice - this.hotData.finalPrice).toFixed(2);
        if (money % 1 === 0) {
          money = Math.trunc(money);
        }
        this.signMoney = money;
      }
    },
    openConfirm(card) {
      this.card = card;
      this.showBuyConfirm = true;
      UBT.moduleExpose({
        pageId: 'platform_appmarketing',
        categoryId: 'platform',
        moduleId: 'platform_floating',
        contentId: 'platform_floating',
        exposureTimes: 1,
        businessInfo: {
          card_name: this.card.title,
          business: this.card.businessType,
        },
      });
    },
    closeConfirm() {
      this.showBuyConfirm = false;
      this.openWanliu();
    },
    getDate() {
      const date = new Date();
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    openWanliu() {
      const nowDate = this.getDate();
      const wanliuDate = Storage.getItem('wanliu-date');
      if (nowDate !== wanliuDate) {
        this.openWanliuWindow = true;
        Storage.setItem('wanliu-date', nowDate);
        if (this.wanliuStyle === 'v1') {
          UBT.moduleExpose({
            pageId: 'platform_appmarketing',
            categoryId: 'platform',
            moduleId: 'platform_Retain',
            contentId: 'platform_Retain',
            exposureTimes: 1,
            businessInfo: {},
          });
          this.$refs.wanliu.open({
            info: this.card,
            title: '确定放弃优惠？',
            timeout: this.card.expiredTime,
          });
        } else {
          UBT.moduleExpose({
            pageId: 'platform_appmarketing',
            categoryId: 'platform',
            moduleId: 'platform_Retain_coupon',
            contentId: 'platform_Retain_coupon',
            exposureTimes: 1,
            businessInfo: {},
          });
          this.$refs.wanliu.open({
            info: this.firstCoupon,
            title: '优惠不合适？',
            subtitle: '为您挑选超值特惠',
          });
        }
      }
    },
    closeWanliu() {
      this.openWanliuWindow = false;
    },
    toBuyWanliu() {
      this.onConfirmRight();
      this.openWanliuWindow = false;
    },
    goDownload() {
      UBT.clickButton({
        pageId: 'platform_appmarketing',
        buttonName: 'platform_down',
        categoryId: 'platform',
        businessInfo: {},
      });
      if (env.isWechatMini) {
        window.location.href = 'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280';
        return;
      }
      this.goUrl(this.config.deepLink, true);
    },
    // 点击下载app
    goUrl(url = this.config.deepLink, download = false) {
      UBT.clickButton({
        pageId: 'platform_appmarketing',
        buttonName: 'platform_down',
        categoryId: 'platform',
        businessInfo: {},
      });
      if (download && (env.isAliMP || env.isAliMPMonitor)) {
        startApp(url);
        return;
      }
      window.location.href = url;
    },
    onConfirmRight() {
      this.showBuyConfirm = false;
      if (this.card) {
        this.card.params = {};
        this.card.params.channelCode = this.card.cardDetail.channelCode;
        this.card.params.shelfGuid = this.card.cardDetail.shelfGuid;
        this.card.params.businessType = this.card.cardDetail.businessType;
        this.card.cardDetail.paymentLimit = this.card.paymentLimit;
        //  actionOrigin, shelfGuid, businessType, channelCode, returnUrl,
        CardService.buy(this.card.cardDetail, Object.assign(this.card.params || {}, {
          returnUrl: `https://m.hellobike.com/AppPlatformH5/${config.envUrlMixin}latest/pr_index_card-for-app.html#/card-for-app-successC?cardTitle=${encodeURIComponent(this.card.title)}`,
        }), 3)
          .then(() => { this.goSuccess(); });
      }
    },
    goSuccess() {
      this.$router.push({
        path: '/card-for-app-successC',
        query: { cardTitle: this.card.title },
      });
    },
    async hotBuy() {
      UBT.moduleExpose({
        pageId: 'platform_appmarketing',
        categoryId: 'platform',
        moduleId: 'platform_floating',
        contentId: 'platform_floating',
        exposureTimes: 1,
        businessInfo: {
          card_name: this.card.title,
          business: this.card.businessType,
        },
      });
      this.card = this.hotData;
      if (this.card.isCard) {
        this.showBuyConfirm = true;
      } else {
        const { token, adCode, cityCode } = await getTokenAndLocation();
        window.location.href = ParamsUtil.addParams(this.card.buttonLink,
          { token, adCode, cityCode });
      }
    },
  },
};
</script>
<style scoped lang="less">
.page {
  height: 100vh;
}

.have-data {
  height: 100%;
  background: #f0f3f5;
}

.content {
  height: 100%;
  background: #ffdaba;
}

.card-container-block {
  background-image: url(https://m.hellobike.com/resource/helloyun/08345/3DgCaqX5sK.png?x-oss-process=image/quality,q_80);
  background-size: 100% 100%;
  height: 4.06rem;
  overflow: hidden;

  .rule-block {
    width: 0.46rem;
    height: 0.2rem;
    margin-top: 0.3rem;
    float: right;

    img {
      width: 0.46rem;
      height: 0.2rem;
    }
  }

  .lottie {
    position: absolute;
    left: 0;
    top: -10%;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .hot-block {
    height: 1.92rem;
    background:
      linear-gradient(
        270deg,
        rgba(255, 255, 255, 0.9) 0%,
        rgba(255, 255, 255, 0.98)
      );
    border-radius: 0.12rem;
    margin: 1.12rem 0.12rem 0 0.12rem;
    overflow: hidden;

    .hot-block-title {
      height: 0.38rem;
      display: flex;
      padding: 0.09rem 0.15rem;

      .title-word {
        font-size: 16px;
        font-family: PingFangSCHeavy, sans-serif;
        color: #242729;
        font-weight: 600;
      }
    }

    .title-time {
      margin-top: 0.03rem;
      margin-left: 0.06rem;
      display: flex;

      .title-time-block {
        width: 0.16rem;
        height: 0.16rem;
        background: #fe4f51;
        border-radius: 0.02rem;
        font-size: 0.12rem;
        font-family: DINAlternate-Bold, DINAlternate, sans-serif;
        font-weight: bold;
        color: #fff;
        text-align: center;
        line-height: 0.16rem;
      }

      .title-time-block-dot {
        line-height: 0.14rem;
        margin-left: 0.01rem;
        margin-right: 0.01rem;
        color: #fe4f51;
      }
    }

    .hot-block-info {
      background: #fff;
      height: 1.54rem;
      border-radius: 0.12rem;
      padding: 0.12rem 0.16rem 0.16rem 0.16rem;

      .buy-btn {
        margin-top: 0.16rem;
        height: 0.42rem;
        position: relative;

        .btn-sign {
          position: absolute;
          top: -0.2rem;
          right: 0.1rem;
          width: 0.88rem;
          height: 0.22rem;
          background-image: url(https://m.hellobike.com/resource/helloyun/08345/CpHXif4prw.png?x-oss-process=image/quality,q_80);
          background-size: 100% 101%;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #242729;
          text-align: center;
          z-index: 1;

          span {
            line-height: 0.19rem;
            display: block;
            font-size: 0.1rem;
          }
        }
      }
    }
  }
}

.card-list {
  margin-top: -0.87rem;
  background: #f0f3f5;
  border-radius: 0.16rem 0.16rem 0 0;

  .card-list-title {
    padding: 0.16rem 0 0 0.2rem;
    font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
    font-weight: 600;
    color: #242729;
    background: linear-gradient(180deg, #fff 0%, #f0f3f5 100%);
    margin-bottom: 0.08rem;
    border-radius: 0.16rem 0.16rem 0 0;
  }

  .second-title {
    font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
    font-weight: 600;
    color: #242729;
    padding: 0.12rem 0 0.08rem 0.2rem;
  }

  .first-cardList {
    margin: 0 0.12rem;
    margin-bottom: 0.08rem;
    height: 0.96rem;
    background: #fff;
    border-radius: 0.12rem;
    padding: 0.12rem;
  }

  .second-cardList {
    margin: 0 0.12rem;
    margin-bottom: 0.08rem;
    height: 0.96rem;
    background: #fff;
    border-radius: 0.12rem;
    padding: 0.12rem;
  }

  .godownload {
    display: flex;
    justify-content: center;
    margin-top: 0.17rem;
    font-size: 0.12rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #000;
    padding-bottom: 0.32rem;

    .download-img {
      width: 0.16rem;
      height: 0.16rem;
      margin-right: 0.04rem;

      img {
        width: 0.16rem;
        height: 0.16rem;
      }
    }

    .download-arrow {
      margin-left: 0.02rem;
      width: 0.04rem;
      height: 0.07rem;

      img {
        width: 0.04rem;
        height: 0.07rem;
      }
    }
  }
}

.no-list-block {
  background: #ffdaba;
  padding: 0 0.12rem;
  margin-top: -0.87rem;
  padding-bottom: 0.17rem;

  .no-list-title {
    font-size: 0.16rem;
    font-family: PingFangTC-Semibold, PingFangTC, sans-serif;
    font-weight: 600;
    color: #242729;
    line-height: 0.22rem;
  }

  .no-list-banner {
    margin-top: 0.08rem;
    border-radius: 0.12rem;

    .banner-container {
      width: 100%;
      display: flex;
      justify-content: center;
      height: 0.8rem;
    }

    /deep/ .wrapper {
      height: 0.8rem;
      border-radius: 0.12rem;
    }
  }

  .no-list-download {
    margin-top: 0.16rem;

    img.no-img {
      width: 100%;
    }
  }

  .no-list-img-block {
    height: 100%;
    background: #ffdaba;
  }
}

.no-data {
  padding-top: 2rem;

  .nodata-img {
    display: flex;
    justify-content: center;

    .lottieNodata {
      width: 2rem;
    }
  }

  .nodata-info {
    text-align: center;
  }
}
</style>
